import { render, staticRenderFns } from "./button-box-arrow-left.vue?vue&type=template&id=7b4ae9e0&"
import script from "./button-box-arrow-left.vue?vue&type=script&lang=ts&"
export * from "./button-box-arrow-left.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports